/**************************************************
 * Nombre:       Seccion_Pagos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, TextField, Typography} from "@mui/material";
import Datos_Pago from "./Componentes/SubComponentes/Datos_Pago";
import BotonPagos from "../../Modulo_Pasarela_Pagos/Componentes/BotonPagos";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import logo_png from '../../Recursos/logo_png.png'
import {useEffect, useState} from "react";
import {collection, query, where} from "firebase/firestore";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import {theme} from "../../Tema";
import {useParams} from "react-router-dom";
import {useReciboPago} from "../../Modulo_Pasarela_Pagos/Hooks/useReciboPago";


const Seccion_Pagos = () => {
    const {sCell, masSM} = useResponsive()
    const parms = useParams()
    const {Dialogo, abrirRecibo} = useReciboPago({logo: logo_png})
    const [numero, setNumero] = useState('')
    const {Cargador, Avisos, nuevoAviso, iniciarCarga, terminar} = useCargador({logoRedondo: logo})
    const [cobro, setCobro] = useState({})


    const consultarCobro = () => {

        if (!numero) {
            alert('Por favor ingrese el numero del pago')
            return
        }

        iniciarCarga('Consultando...')
        let q = query(collection(fire, 'pagos'), where('consecutivo', '==', parseInt(numero)))
        obtenerColeccionQuery(q).then((dox) => {


            if (dox.res && dox.data[0]) {
                let cobro = dox.data[0]

                if (cobro.fechaPago) {
                    abrirRecibo(cobro)
                    setCobro(cobro)
                } else {
                    setCobro(cobro)
                }

                terminar({aviso: 'Consulta realizada con exito'})

            } else {
                terminar({aviso: 'No existe ningun registro con ese numero de orden', variante: 'error'})
            }


        })
    }


    useEffect(() => {


        if (parms && parms.id) {
            setNumero(parms.id)
            consultarCobro(parms.id)
        }

    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: 18}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >

                        <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop: 4}}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="flex-start"
                            >

                                <Grid item container size={12} sx={{justifyContent: 'center'}}>
                                    <Typography sx={{fontSize: sCell ? 12 : 18, fontWeight: 400}}>
                                        Pagos y Reservaciones
                                    </Typography>
                                </Grid>

                                <Grid item container size={12} sx={{justifyContent: 'center'}}>
                                    <Typography sx={{fontSize: sCell ? 24 : 36, fontWeight: 700, textAlign: 'center'}}>
                                        REALIZA TU PAGO AQUI
                                    </Typography>
                                </Grid>

                                <Grid item container size={12} sx={{justifyContent: 'center'}}>
                                    <Typography sx={{
                                        fontSize: 16,
                                        fontWeight: 400,
                                        textAlign: 'center'
                                    }}>
                                        Ingresa el numero de tu orden, verifica si la informacion es correcta y realiza
                                        el
                                        pago</Typography>
                                </Grid>

                                <Grid item container size={12} sx={{justifyContent: 'center', marginTop: 4}}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        spacing={2}
                                    >

                                        <Grid item container size={8} sx={{justifyContent: 'flex-start'}}>
                                            <TextField
                                                value={numero}
                                                onChange={(e) => setNumero(e.target.value)}
                                                variant={'outlined'} label={"Order number"}/>
                                        </Grid>

                                        <Grid item container size={4} sx={{justifyContent: 'flex-start'}}>
                                            <Button
                                                onClick={() => consultarCobro()}
                                                sx={{color: theme.palette.primary.main}}
                                                color={'primary'} variant={'outlined'}>Consultar</Button>
                                        </Grid>

                                    </Grid>

                                </Grid>

                                <Grid item container size={12} sx={{justifyContent: 'flex-start', marginTop: 4}}>
                                    <Datos_Pago item={cobro}/>
                                </Grid>

                                <Grid container size={12}
                                      sx={{justifyContent: 'center', marginTop: 6, marginBottom: 6}}>
                                    {cobro && cobro.valor && !cobro.referencia &&
                                        <BotonPagos valor={cobro.valor} idPedido={cobro.id}
                                                    descripcion={`Numero de Pago ${cobro.consecutivo}`}/>
                                    }
                                </Grid>


                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Pagos